import React, { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert"; // Kebab menu icon
import EditIcon from "@mui/icons-material/Edit"; // Edit icon
import DeleteIcon from "@mui/icons-material/Delete"; // Delete icon
import VisibilityIcon from "@mui/icons-material/Visibility"; // View icon
import { Box, Divider, MenuItem } from "@mui/material";
import { StyledIconButton, StyledMenu } from "./styled";
interface IProps {
  hideEditOption?: boolean;
  hideDeleteOption?: boolean;
  hideViewOption?: boolean;
  handleEditMenuClick?: () => void;
  handleDeleteMenuClick?: () => void;
  handleViewMenuClick?: () => void;
  color?: string;
  onClose?: () => void; // New prop to close the menu
}

const EditDeleteMenu: React.FC<IProps> = ({
  hideEditOption = false,
  hideDeleteOption = false,
  hideViewOption = false,
  handleEditMenuClick,
  handleDeleteMenuClick,
  handleViewMenuClick,
  color,
  onClose, // Add onClose prop
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
    if (onClose) onClose(); // Close the menu and trigger the onClose callback
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <Box>
      <StyledIconButton
        data-testid="edit-delete-menu"
        aria-label="article-action-button"
        aria-controls={open ? "article-action-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon sx={{ fontSize: 40 }} color={"action"} />
      </StyledIconButton>

      {open && (
        <StyledMenu
          id="article-action-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "article-action-button",
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          {!hideViewOption && (
            <Box>
              <MenuItem
                data-testid="view-menu-item"
                onClick={() => {
                  handleViewMenuClick?.();
                  handleClose();
                }}
              >
                <VisibilityIcon sx={{ marginRight: 2 }} /> View
              </MenuItem>
            </Box>
          )}
          {!hideEditOption && (
            <Box>
              <Divider />
              <MenuItem
                data-testid="edit-menu-item"
                onClick={() => {
                  handleEditMenuClick?.();
                  handleClose();
                }}
              >
                <EditIcon sx={{ marginRight: 2 }} /> Edit
              </MenuItem>
            </Box>
          )}
          {!hideDeleteOption && (
            <Box>
              <Divider />
              <MenuItem
                data-testid="delete-menu-item"
                onClick={() => {
                  handleDeleteMenuClick?.();
                  handleClose(); // Close menu after delete is triggered
                }}
              >
                <DeleteIcon sx={{ marginRight: 2 }} /> Delete
              </MenuItem>
            </Box>
          )}
        </StyledMenu>
      )}
    </Box>
  );
};

export default EditDeleteMenu;
